exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:1200px){.admin-sidebar-list img[_v-ca4c810c]{padding-right:0}.admin-sidebar-list[_v-ca4c810c]{text-align:center;padding:10px 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-ca4c810c&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Admin/Admin-sidebar.vue
// module id = 459
// module chunks = 0